"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSurplusLines = void 0;
var tslib_1 = require("tslib");
var util_1 = require("../lib/util");
function useSurplusLines() {
    return {
        showAddSurplusFeeButton: function (surplusLines) {
            return surplusLines ? util_1.surplusLineOptions.length > surplusLines.length : true;
        },
        getAvailableSurplusLineOptions: function (billingDetails) {
            return util_1.surplusLineOptions.map(function (option) { return ((0, tslib_1.__assign)((0, tslib_1.__assign)({}, option), { disabled: (0, util_1.getIsDisabled)(option.value, billingDetails) })); });
        },
    };
}
exports.useSurplusLines = useSurplusLines;
//# sourceMappingURL=use-surplus-lines.js.map